import { render, staticRenderFns } from "./AromoreView.vue?vue&type=template&id=4ecad9bb&scoped=true"
import script from "./AromoreView.vue?vue&type=script&lang=js"
export * from "./AromoreView.vue?vue&type=script&lang=js"
import style0 from "./AromoreView.vue?vue&type=style&index=0&id=4ecad9bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecad9bb",
  null
  
)

export default component.exports